export enum EnumConsoleType {
	INFO = 'INFO',
	WARNING = 'WARNING',
	ERROR = 'ERROR',
	SUCCESS = 'SUCCESS',
	REQUEST = 'REQUEST'
}
